import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const SUPPORTED = ["it", "en", "fr", "de", "es"];

const detectLang = () => {
  const saved = localStorage.getItem("lang");
  if (saved && SUPPORTED.includes(saved)) return saved;
  const nav = (navigator.language || "it").slice(0, 2).toLowerCase();
  return SUPPORTED.includes(nav) ? nav : "it";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectLang);

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang] || translations.it;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
